import createIcon from '../../createIcon';

/**
 * @component @name RollerShades
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMTlWM0g0VjE5SDJWMjFIMjJWMTlIMjBaTTYgMTlWMTNIMTFWMTQuOEMxMC42IDE1LjEgMTAuMiAxNS42IDEwLjIgMTYuMkMxMC4yIDE3LjIgMTEgMTggMTIgMThDMTMgMTggMTMuOCAxNy4yIDEzLjggMTYuMkMxMy44IDE1LjYgMTMuNSAxNS4xIDEzIDE0LjhWMTNIMThWMTlINloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const RollerShades = createIcon('RollerShades', [
  [
    'path',
    {
      d: 'M20 19V3H4V19H2V21H22V19H20ZM6 19V13H11V14.8C10.6 15.1 10.2 15.6 10.2 16.2C10.2 17.2 11 18 12 18C13 18 13.8 17.2 13.8 16.2C13.8 15.6 13.5 15.1 13 14.8V13H18V19H6Z',
      key: '15erg6',
    },
  ],
]);

export default RollerShades;
